import type { JobPostingEntitlement, PerformanceBasedEntitlement } from '../../../state/reducers/entitlement/entitlement'
import { BASE_NEXT_API, getApiUrl } from '../../util/api/api'

const createJob = async (product: JobPostingEntitlement | PerformanceBasedEntitlement | null): Promise<any> => {
  const fetchResponse = await fetch(
    getApiUrl(`${BASE_NEXT_API}/job/create`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify({ product }),
    }
  )

  if (fetchResponse?.ok) {
    const responseData = await fetchResponse.text()
    return Promise.resolve({ status: fetchResponse.status, data: responseData })
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}

export default createJob
